import { Typography } from "@atoms/typography";
import { FC } from "react";
import styled from "styled-components";

export type FAQItemProps = {
  title: string;
  content: string;
};
export const FAQItem: FC<FAQItemProps> = ({ title, content }) => {
  return (
    <Container className="faq-element">
      <Typography variant="title2">{title}</Typography>
      <Typography variant="body1">{content}</Typography>
    </Container>
  );
};

const Container = styled.div`
`;
